export interface MarketingStep {
    title: string;
    body: string;
    image: string;
    alt: string;
}

/** Numbered how-to steps with real product screenshots. */
export function StepList({ title, lead, steps }: { title: string; lead: string; steps: readonly MarketingStep[] }) {
    return (
        <section className="mktg-steps">
            <div className="mktg-container">
                <h2 className="mktg-section-title">{title}</h2>
                <p className="mktg-section-lead">{lead}</p>
                <ol className="mktg-step-list">
                    {steps.map((step) => (
                        <li className="mktg-step" key={step.title}>
                            <img src={step.image} alt={step.alt} width={600} height={400} loading="lazy" />
                            <div>
                                <h3>{step.title}</h3>
                                <p>{step.body}</p>
                            </div>
                        </li>
                    ))}
                </ol>
            </div>
        </section>
    );
}
